import { ViewChild } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { SelectComponent } from 'ng2-select';
import { ToastrService } from 'ngx-toastr';
import { AdminPortalDatePickerModes } from '../../../shared/components/admin-portal-date-picker/admin-portal-date-picker.component';
import { APIOperableComponent } from '../../../shared/components/api-operable/api-operable.component';
import { NgSelectOptionModel } from '../../../shared/model/ng-select-option.model';
import { SortUtils } from '../../../shared/utils/sort.utils';
import { AssetTypeModel } from '../../asset/components/model/asset-type.model';
import { AssetService } from '../../asset/service/asset.service';
import { MakeModel } from '../../make/model/make.model';
import { AuthService } from '../../security/service/auth.service';
import { ProductUIMessages } from '../model/product-ui.messages';
import { ProductModel } from '../model/product.model';
import { ProductWarrantyDuration } from '../model/product_warranty_duration';
import { ProductService } from '../service/product.service';

export class ProductBaseComponent extends APIOperableComponent {
  @ViewChild('typeIdComponent', { static: true })
  protected ngSelectTypes: SelectComponent;
  protected partAndProductModel = new ProductModel();
  protected productWarrantyDuration = new ProductWarrantyDuration();
  protected makes: Array<NgSelectOptionModel>;
  protected makesData: Array<NgSelectOptionModel>;
  protected assetTypes: Array<AssetTypeModel>;
  protected assetTypesData: Array<AssetTypeModel>;
  protected DATEPICKER_MODES = AdminPortalDatePickerModes;

  constructor(
    protected progressService: NgProgress,
    protected toastr: ToastrService,
    protected authService: AuthService,
    protected productService: ProductService,
    protected assetService: AssetService
  ) {
    super(progressService, toastr, authService);
    this.makesData = [];
  }

  /**
   * Get the list of makes
   */
  protected loadMakesList() {
    this.productService.getProductMakesForNgSelect().subscribe(
      (result: Array<NgSelectOptionModel>) => {
        this.makes = result;
        this.makesData = this.makes.slice(0);
      },
      err => this.onAPIError(ProductUIMessages.LOAD_MAKES_ERROR)
    );
  }

  /**
   * Loads the list of asset types.
   */
  protected loadAssetTypes(): void {
    this.assetService.getAssetTypes().subscribe(
      (result: Array<AssetTypeModel>) => {
        this.assetTypes = result.filter(assetType => {
          return assetType.isActive;
        });
        this.assetTypesData = SortUtils.sortCollection(
          this.assetTypes.slice(0),
          'name'
        );
      },
      error => this.onAPIError('Error while loading Asset Types.')
    );
  }

  /**
   * Removes Make value from the product model.
   */
  protected onRemovedMake(): void {
    this.partAndProductModel.makeId = null;
    this.partAndProductModel.make = null;
  }

  /**
   * Sets the Make field on the product model.
   * @param type
   */
  protected onSelectedMake(make: NgSelectOptionModel): void {
    if (make) {
      this.partAndProductModel.makeId = make.id;
      this.partAndProductModel.make = new MakeModel();
      this.partAndProductModel.make.id = make.id;
      this.partAndProductModel.make.name = make.text;
    }
  }

  /**
   * Filters Makes combox items by input value.
   * @param value
   */
  protected handleMakesComboBoxFilter(value) {
    this.makesData = this.makes.filter(
      s => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  /**
   * Sets the Make field on the product model.
   * @param type
   */
  protected onSelectedAssetType(assetType: AssetTypeModel): void {
    if (assetType) {
      this.partAndProductModel.assetTypeId = assetType.id;
    }
  }

  /**
   * Filters Makes combox items by input value.
   * @param value
   */
  protected handleAssetTypeComboBoxFilter(value) {
    this.assetTypesData = this.assetTypes.filter(
      s => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
}
